import React from 'react';

export default class LoadingPageContent extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="text-center">
                <span className="glyphicon glyphicon-refresh glyphicon-spin padding-lr10 text250" />
                <br />
                ...loading...
            </div>
            );
    }
}